import { Avatar, Box, Typography } from '@mui/material';
import React from 'react';
import { Icons } from '../../../icons/Icons';
import { InviteInfoFeatureListItemType } from '../types';

type InviteInfoFeatureListItemProps = InviteInfoFeatureListItemType;

export default function InviteInfoFeatureListItem({ iconName, title, description }: InviteInfoFeatureListItemProps) {
    return (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            <Avatar
                sx={{
                    bgcolor: 'primary.main',
                    width: 40,
                    height: 40,
                    flexShrink: 0
                }}
            >
                {Icons[iconName] && React.createElement(Icons[iconName])}
            </Avatar>
            <Box sx={{ flex: 1 }}>
                <Typography
                    variant="subtitle1"
                    sx={{
                        color: 'inviteInfo.titleText',
                        fontWeight: 700,
                        mb: 0.5
                    }}
                >
                    {title}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'inviteInfo.descriptionText'
                        }}
                    >
                        {description}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
